<div class="sidebar-container">
  <div class="header">
    <h2>{{ 'Questions.AnalysisHeader' | translate }}</h2>
    <button mat-icon-button (click)="closeSidebar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="suggestions-section">
      <p class="section-title">{{ 'Questions.SuggestionsTitle' | translate }}</p>
      <div class="chips-grid">
        @for (suggestion of quickSuggestions; track suggestion) {
          <button class="suggestion-chip" (click)="generateAnalysis(suggestion)" [disabled]="loading()">
            <mat-icon>lightbulb_outline</mat-icon>
            {{ suggestion }}
          </button>
        }
      </div>
    </div>

    @if (reports().length > 0) {
      <div class="history-section">
        <p class="section-title">{{ 'Questions.AnalysisHistory' | translate }}</p>
        <div class="history-list">
          @for (version of formattedReports(); track version._id) {
            <app-version-tile
              [version]="version"
              [isActive]="currentReport()?._id === version._id"
              [showInsertAction]="false"
              (restore)="selectReport(version)"
              (delete)="deleteReport($event, version)"
            ></app-version-tile>
          }
        </div>
      </div>
    }

    @if (error()) {
      <div class="px-4">
        <div class="error-state mt-4 skz-alert error">
          <mat-icon>error_outline</mat-icon>
          {{ error() }}
        </div>
      </div>
    }

    <div class="input-section">
      <mat-form-field appearance="fill" class="w-100" subscriptSizing="dynamic">
        <textarea matInput [(ngModel)]="searchQuery" [placeholder]="'Questions.AnalysisPlaceholder' | translate" rows="3" (keydown.enter)="generateAnalysis()"></textarea>
      </mat-form-field>

      <app-loading-button
        class="w-100 mt-3"
        [label]="'Questions.ActionGenerate' | translate"
        [loading]="loading()"
        [disabled]="!searchQuery()"
        [icon]="'auto_awesome'"
        className="w-100"
        (clicked)="generateAnalysis()"
      ></app-loading-button>
    </div>
  </div>
</div>
